module.exports = __webpack_public_path__ + "img/security.33746a54.svg";